import refs from '../helpers/refs'

class CInputText {
  constructor (el) {
    this.$root = el
    this.$refs = refs(this.$root)

    this.init()
  }

  init () {
    // Input hover states
    this.$refs.input.addEventListener('focus', () => {
      this.$root.classList.add('active')
    })
    this.$refs.input.addEventListener('blur', () => {
      this.$root.classList.remove('active')
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.a-input-text')
    .forEach(el => new CInputText(el))
})
